import React from 'react';
import BaseTemplate from './BaseTemplate';

const LeadTemplate = ({ data }) => {
  return <BaseTemplate data={data} />;
};

export default LeadTemplate;
